import { Device, DeviceConfig, DeviceLocationDto } from '@thingslog/repositories';
import clsx from 'clsx';
import React, { FC, useState, useEffect } from 'react';
import { Panel, PanelTitle } from './base';
import { InfoRow, InfoRowsViewer } from './base/InfoRowsViewer';
import { useTranslation } from 'react-i18next';

const formatCoordinate = (coordinate?: number): string | null => {
  return typeof coordinate === 'number' && Number.isFinite(coordinate)
    ? coordinate.toString()
    : null;
};

export const DeviceInfo: FC<Props> = ({
  className,
  device,
  deviceConfig,
  deviceLocation,
  linkedDevices,
  onLinkedDeviceClick,
  distanceTraveledKm,
}: Props) => {
  const { t, i18n } = useTranslation();
  const [rows, setRows] = useState<InfoRow[]>([]);

  useEffect(() => {
    const rows: InfoRow[] = [];
    if (device !== undefined) {
      rows.push({ type: 'default', title: `${t('device_information_name')}:`, value: device.name });
      rows.push({
        type: 'default',
        title: `${t('device_information_number')}:`,
        value: device.number,
      });
      rows.push({
        type: 'default',
        title: `${t('device_information_model')}:`,
        value: device.model,
      });
      rows.push({
        type: 'default',
        title: `${t('device_information_latitude')}:`,
        value: formatCoordinate(deviceLocation?.latitude),
      });
      rows.push({
        type: 'default',
        title: `${t('device_information_longitude')}:`,
        value: formatCoordinate(deviceLocation?.longitude),
      });
      if (
        device.description !== null &&
        device.description !== undefined &&
        device.description.length > 0
      ) {
        rows.push({
          type: 'default',
          title: `${t('field_info_description')}`,
          value: device.description,
        });
      }
    }
    if (deviceConfig !== undefined) {
      rows.push({ type: 'default', title: `${t('time_zone')}:`, value: deviceConfig.timeZone });
    }
    // if (distanceTraveledKm !== undefined && distanceTraveledKm > 0) {
    //   rows.push({
    //     type: 'default',
    //     title: `${t('field_info_distance_traveled')}:`,
    //     value: `${distanceTraveledKm.toFixed(2)} km`,
    //   });
    // }
    if (device?.number) {
      rows.push({
        type: 'link',
        title: `${t('field_info_alarms')}`,
        value: `${t('field_info_view')}`,
        link: `/alarms?devNum=${device.number}`,
      });
    }
    if (linkedDevices !== undefined && linkedDevices.length > 0) {
      rows.push({
        type: 'list',
        title: `${t('field_info_linked_devices')}`,
        items: linkedDevices,
        onItemClick: onLinkedDeviceClick,
      });
    }
    setRows(rows);
  }, [device, deviceConfig, deviceLocation, i18n.language, linkedDevices, distanceTraveledKm, t]);

  return (
    <Panel className={clsx('space-y-2.5', className)}>
      <PanelTitle title={t('default_information_panel')} />
      <InfoRowsViewer rows={rows} />
    </Panel>
  );
};

interface Props {
  device?: Device;
  deviceConfig?: DeviceConfig;
  deviceLocation?: DeviceLocationDto;
  linkedDevices?: string[];
  className?: string;
  onLinkedDeviceClick?: (deviceNumber: string) => void;
  distanceTraveledKm?: number;
}
